import type { Item } from '../content/types.ts';
import type { CustomItemLibrary } from '../domain/customItem.ts';
import {
  createCustomItemLibrary,
  migrateCustomItemLibraryRecord,
  validateCustomItemLibrary,
} from '../domain/customItem.ts';
import type { StoragePort } from './storagePort.ts';
import { WriteQueue } from './writeQueue.ts';
import { CustomContentRepository } from './customContentRepository.ts';

/**
 * The player's own Item definitions.
 *
 * Reading, the write lock on an unreadable file, validation, the write queue
 * and the bounded backups all come from `CustomContentRepository` - the same
 * ones custom Skills and Backgrounds get. This supplies only what is specific
 * to Items, so the protections cannot drift apart.
 */
export class CustomItemRepository extends CustomContentRepository<CustomItemLibrary> {
  constructor(
    storage: StoragePort,
    now: () => string = () => new Date().toISOString(),
    queue: WriteQueue = new WriteQueue(),
  ) {
    super(
      {
        name: 'custom-items',
        label: 'custom Item',
        createEmpty: createCustomItemLibrary,
        migrate: migrateCustomItemLibraryRecord,
        validate: validateCustomItemLibrary,
      },
      storage,
      now,
      queue,
    );
  }

  async saveItems(library: CustomItemLibrary, items: readonly Item[]): Promise<CustomItemLibrary> {
    return this.save({ ...library, items: [...items] });
  }
}
